import { Cancel01Icon } from '@hugeicons/react'
import clsx from 'clsx'

type DismissButtonProps = {
  onClick: () => void
  'aria-label'?: string
  className?: string
}

/**
 * Canonical close control for sheets and drawers — red square, high contrast.
 * Reused anywhere the participant dismisses an overlay (MobileSheet, AppMenu, …).
 */
export function DismissButton({
  onClick,
  'aria-label': ariaLabel = 'Fechar',
  className
}: DismissButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={clsx(
        'flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-[var(--color-danger)] text-white transition-colors hover:bg-[var(--color-danger-active)] active:opacity-90',
        className
      )}
    >
      <Cancel01Icon size={18} variant="stroke" />
    </button>
  )
}
